import { FunctionComponent } from "react";
import { FloorItemModel } from "../models/floorItem.model";
import { RouteBuilder } from "../../router/constantes/routes.const";
import { EditIonCardList } from "../../shared/components/edit-ion-card-list.component";
import { useOrganizationCode } from "../../router/hooks/use-organization-code.hook";
import { useLocale } from "../../router/hooks/use-locale.hook";

export interface BuildingListProps {
  siteId: string;
  buildingId: string;
  floorList: FloorItemModel[];
  floorListTitleLabel: string;
  isExported?: boolean;
  buildingAddress?: string;
}

export const FloorList: FunctionComponent<BuildingListProps> = ({
  siteId,
  buildingId,
  floorList,
  isExported,
  floorListTitleLabel,
  buildingAddress
}) => {
  const organizationCode = useOrganizationCode();
  const locale = useLocale();
  
  return (
    <EditIonCardList
      list={floorList.map((floor) => ({ 
        id: floor.id, 
        name: floor.name, 
        icon: floor.icon, 
        numberOfAnnotations: floor.numberOfAnnotations,
        isGraphic: floor.isGraphic,
        isExported: isExported || false,
        numberOfExportedBuildings: 0,
        numberOfBuildings: 0
      }))}
      title={floorListTitleLabel}
      subtitle={buildingAddress}
      getRouterLink={(floorId: string) => RouteBuilder.floor(siteId, buildingId, floorId, locale, organizationCode)}
      isBuildingList={false}
    />
  );
};
